module.exports = __webpack_public_path__ + "img/9791166680113.b2ecf294.jpg";